export const resolveContentRoot = (itemId: string): HTMLElement | null =>
    document.querySelector<HTMLElement>(`[data-anchor-root="${itemId}"]`);
